/* Quote confirmation and phone intent only. Never read or publish form values. */
(function () {
  'use strict';
  if (window.JaksLeadTrackingLoaded) return;
  window.JaksLeadTrackingLoaded = true;

  var pendingKey = 'jaks:quote-pending:v1';
  var maxAge = 30 * 60 * 1000;
  var confirmationHandled = false;
  var lastPhoneClick = 0;
  var privacyRequested = false;

  function permitted() {
    try {
      var privacy = window.Shopify.customerPrivacy;
      return !window.Shopify.designMode && privacy.analyticsProcessingAllowed() === true;
    } catch (e) { return false; }
  }

  function environment() {
    // Unknown theme roles fail closed in the receiver. Preview clicks stay out of GA4.
    return window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'main' ? 'live' : 'preview';
  }

  function pageType() {
    var config = document.getElementById('jaks-lead-tracking');
    return config ? config.getAttribute('data-page-type') : 'unknown';
  }

  function discardPending() {
    try { window.sessionStorage.removeItem(pendingKey); } catch (e) { /* Storage is optional. */ }
  }

  function pending() {
    try {
      var record = JSON.parse(window.sessionStorage.getItem(pendingKey));
      var age = record && Date.now() - record.created;
      if (record && age >= 0 && age <= maxAge && record.environment === environment()) return record;
    } catch (e) { /* Blocked/corrupt storage must not affect the form. */ }
    discardPending();
    return null;
  }

  function publish(name, data) {
    try {
      if (!permitted() || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return false;
      var result = window.Shopify.analytics.publish(name, data);
      if (result && typeof result.catch === 'function') result.catch(function () {});
      return result !== false;
    } catch (e) { return false; }
  }

  function checkConfirmation() {
    if (confirmationHandled || !document.querySelector('#QuoteForm [data-jaks-quote-success]') || !permitted()) return;
    if (!pending()) return;
    if (publish('jaksdiesel:lead', {
      lead_source: 'quote_form', method: 'form_submit', tracking_version: 2,
      tracking_environment: environment(), page_type: pageType()
    })) {
      confirmationHandled = true;
      discardPending();
    }
  }

  function ready() {
    var shopify = window.Shopify;
    if (shopify && !shopify.customerPrivacy && !privacyRequested && typeof shopify.loadFeatures === 'function') {
      privacyRequested = true;
      try {
        shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) {
          if (error) privacyRequested = false;
          else checkConfirmation();
        });
      } catch (e) { privacyRequested = false; }
    }
    checkConfirmation();
  }

  function start() {
    var form = document.getElementById('QuoteForm');
    if (form) {
      form.addEventListener('submit', function () {
        // Native validation happens before submit. This records intent, never a lead.
        discardPending();
        if (!permitted()) return;
        try {
          window.sessionStorage.setItem(pendingKey, JSON.stringify({created: Date.now(), environment: environment()}));
        } catch (e) { /* The customer's request still submits normally. */ }
      });
      if (form.querySelector('[data-jaks-quote-error]')) discardPending();
    }
    document.addEventListener('click', function (event) {
      var link = event.target && event.target.closest && event.target.closest('a[href^="tel:"]');
      if (!link || event.defaultPrevented || !permitted()) return;
      var now = Date.now();
      if (now - lastPhoneClick < 750) return;
      if (publish('jaksdiesel:phone_clicked', {
        method: 'phone_link', page_type: pageType(), tracking_version: 2,
        tracking_environment: environment()
      })) lastPhoneClick = now;
      // Do not delay, prevent, or otherwise change the phone link.
    });
    document.addEventListener('visitorConsentCollected', function () {
      if (!permitted()) discardPending();
      checkConfirmation();
    });
    ready();
    // Shopify analytics can finish loading after this deferred asset.
    [250, 1000, 3000].forEach(function (delay) { window.setTimeout(ready, delay); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
}());
